/** Mirrors `analytics.ReportSchedule` (Wave 13). */
export type ReportKey = 'pnl' | 'revenue_by_client' | 'time_tracking' | 'payroll';
export type Cadence = 'daily' | 'weekly' | 'monthly';

export interface ReportSchedule {
  id: number;
  report_key: ReportKey;
  cadence: Cadence;
  recipient_email: string;
  is_active: boolean;
  last_run_at: string | null;
  next_run_at: string | null;
  created: string;
  modified: string;
}

export interface ReportScheduleInput {
  report_key: ReportKey;
  cadence: Cadence;
  recipient_email: string;
  is_active?: boolean;
}

export const REPORT_KEY_LABEL: Record<ReportKey, string> = {
  pnl: 'Profit & Loss',
  revenue_by_client: 'Revenue by client',
  time_tracking: 'Time tracking',
  payroll: 'Payroll',
};

export const CADENCE_LABEL: Record<Cadence, string> = {
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
};
